import React from "react";
import "./index.css"; // Import custom CSS

const FullPageLoader = ({text}) => {
  return (
    <div className="loader-container">
      <div className="spinner"></div>
      <p className="loading-text">{text}</p>
    </div>
  );
};

export default FullPageLoader;
